import { render, staticRenderFns } from "./FocusTrap.vue?vue&type=template&id=97dff766&"
import script from "./FocusTrap.vue?vue&type=script&lang=js&"
export * from "./FocusTrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports